<h2 mat-dialog-title>
  {{(title ? title :'ARE_YOU_SURE') | translate}}?
</h2>
<mat-dialog-content class="content-padding">
  <lina-message *ngIf="body" [content]="body" [theme]="theme"></lina-message>
  <div *ngIf="htmlBody" [innerHTML]="htmlBody">

  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>{{rejectButton | translate}}</button>
  <button mat-button (click)="onSubmit(true)" color="primary">{{acceptButton | translate}}</button>
</mat-dialog-actions>
